
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Loading } from 'element-ui'
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
@Component
export default class Studymap extends Vue {
    myLoading:any = null
    settingData:any = { //设置信息
        StationGUID:"",
        SystemName:""
    }
    dialogVisible:Boolean = false
    user:any = {}
    defaultImg:String = "../../assets/images/studymap/certificate.png"
    courseList:any = {
        courseSummry:{
            Labels:""
        }
    }; 
    chapterArr:Array<any> = [];
    timer:any;    
    @Getter mapSys: any;
    @Getter mapStation: any;
    @Getter mapCourseList:any;
    @Getter mapCourseStatus:any;
    @Getter mapUserSetting:any;
    @Action('getStudyMapStation') getStudyMapStation: Function;
    @Action('getStudyMapSystem') getStudyMapSystem: Function;
    @Action('getStudyMapCourseList') getStudyMapCourseList: Function;
    @Action('getStudyMapCourseStatus') getStudyMapCourseStatus: Function;
    @Action('getStudyMapUserSetting') getStudyMapUserSetting: Function;
    @Action('saveStudyMapUserSetting') saveStudyMapUserSetting: Function;

    mounted() {
        this.getStudyMapStation();
        this.getStudyMapSystem();
        this.getStudyMapUserSetting();
        this.user = JSON.parse(localStorage.logonUser || "{}");
    }

    // 跳转
    loadurl(){    
        var url="";
        url="https://doc.weixin.qq.com/sheet/e3_AV0AtQYYAPUBksbx1XWSb26ssa09b?scode=AIsAVQcAABI9PTJRZPALwAFwYnALY&tab=t5314s";
        window.open(url);
    }    

    // 开始指引
    startGuide() {
        const driver = new Driver({
            allowClose: false,
            doneBtnText: '完成',
            closeBtnText: '关闭',
            nextBtnText: '下一步',
            prevBtnText: '上一步',
            onNext: (Element:any) => {
                if(Element.node.id == 'step4'){
                    (document.querySelector('.layout-box') as any).scrollTop = 0
                }                
            },
            onPrevious: (Element:any) => {
                if(Element.node.id == 'step3'){
                    (document.querySelector('.layout-box') as any).scrollTop = 0
                }                
            }
        })
        driver.defineSteps([
            {
                element: '#step1',
                popover: {
                    title: '选择课程专业线',
                    description: '请根据自己的岗位调整计划参与的课程专业线。不同的专业线会对课程给出差异化的学习要求。',
                    position: 'left'
                }
            },
            {
                element: '#step2',
                popover: {
                    title: '选择课程',
                    description: '点击对应产品线系列课程图片，即可一键切换至对应产品线的学习地图。',
                    position: 'bottom'
                }
            },
            {
                element: '#step3',
                popover: {
                    title: '课程要求及课程分类',
                    description: '此处标明了这节课的课程分类和针对当前专业线的学习要求（掌握、了解、不要求）。',
                    position: 'right'
                }
            },
            {
                element: '#step4',
                popover: {
                    title: '进入学习',
                    description: '点击“开始课程”按钮或课程名称进入课程学习。',
                    position: 'left'
                }
            }
            ,
            {
                element: '#step5',
                popover: {
                    title: '新手指引与学考须知',
                    description: '点击《学考须知》了解学习和考试相关要求，查看其他相关课程学习链接。点击《新手指引》可以重新提供引导说明。',
                    position: 'left'
                }
            }
        ])
        driver.start()
    }

    change(item:any){
        this.settingData.SystemName = item.SystemName
        this.initData()
    }
     // 初始化列表
    initData(){        
        let {StationGUID,SystemName} = this.settingData
        if(StationGUID && SystemName){
            this.saveStudyMapUserSetting({StationGUID,SystemName});
            this.getStudyMapCourseList({StationGUID,SystemName}).then(()=>{                                             
                clearInterval(this.timer);
                this.timer = setInterval(()=>{
                    this.getStudyMapCourseStatus({SystemName});
                    },1000*60*3);
            })

        }
    }
    showLoading(){
        this.myLoading=Loading.service({
            lock: false,
            text: '课程加载中..',

            background: 'rgba(255,255,255,0.85)'
        })
    }   
    hideLoading(){
        this.myLoading.close();
    }
    gotoLearning(row:any){
        window.open(row.CourseUrl)
    }
    formatDuration(val:string){
        let hour = val.split("小时")[0]
        let minute = val.split("小时")[1].split("分钟")[0]
        return `${hour.length > 1 ? hour : "0" + hour}小时${minute.length > 1 ? minute : "0" + minute}分钟`
    }
    get carouselNum(){
        return Math.ceil(this.mapSys.infos.length/6)
    }
    get stationName() {
        let data = this.mapStation.infos.find((item:any)=>this.settingData.StationGUID == item.StationGUID) || {}
        return data.StationName
    }

    get Images(){
        let item = this.mapSys.infos.find((item:any)=>this.settingData.SystemName === item.SystemName)
        if(item){
            return item.Images
        }
        return null
    }
    @Watch('mapCourseList.loading')
    watchStudyMapCourseList(newVal: boolean, oldVal: boolean) {
        // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
        if (oldVal === true && newVal === false) {        
            
            this.courseList = this.mapCourseList;
            let chapter = new Set()
            this.courseList.infos.forEach((item:any) => {
                if(item.Type == "练习"){
                    chapter.add(item.CourseName)
                }
                else{
                    chapter.add(item.Chapter)
                }
                
            });
            this.chapterArr = [...chapter]
        }
    }

    @Watch('mapCourseStatus.loading')
    watchStudyMapCourseStatus(newVal: boolean, oldVal: boolean) {
        // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
        if (oldVal === true && newVal === false) {                    
            this.courseList.infos.forEach((item:any)=>{
                let target:any = this.mapCourseStatus.infos.List.find((s:any)=>item.CourseId ===s.CourseId)
                if(target){
                    item.Status = target.Status
                    item.LearningProgress = target.LearningProgress
                };
            });

            this.courseList.courseSummry.CertificateStatus=this.mapCourseStatus.infos.CourseSummry.CertificateStatus;
            this.courseList.courseSummry.Progress=this.mapCourseStatus.infos.CourseSummry.Progress;
            this.courseList.courseSummry.Percentage=this.mapCourseStatus.infos.CourseSummry.Percentage;
        }
    }

    @Watch('mapUserSetting.loading')
    watchStudyMapUserSetting(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
        if(this.mapUserSetting.infos.length>0){
        this.settingData = this.mapUserSetting.infos[0];
        this.initData();
        }
    }  
  }
    destroyed(){        
        clearInterval(this.timer);
    }}
